export default __webpack_public_path__ + "static/media/IMG_0003.b6d4c2d3.jpg";